import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
import { TopDisplay } from "../../../components";
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useRef} from "react";
// import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Loader } from "../../../customs";
import apiCall from '../../../utils/apiCall';
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom, modalAtom} from "../../../context";
import styled from "@emotion/styled";
import { downloadApi } from "../../../api";
import {
  Grid,
  GridItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import { format } from "date-fns";
import { boolean } from "yup";



const src=`/public-assets/upload_icon.png`;

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function OutstandingDues() {
  const [hide, set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

  // UI state
  const [search, setSearch] = useState<string>("");
  const [hasPaid, setHasPaid] = useState<boolean>(false); // default false
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState<number | null>(null);

  // pagination
  const [currentPage, setCurrentPage] = useState(0); // 0-based for ReactPaginate
  const itemsPerPage = 100;

  // debounce ref for typing
  const searchDebounceRef = useRef<number | null>(null);

  // Helper: fetch a single page from backend
  const fetchPage = async ({ pageNumber, pageSize, hasPaid, searchTerm } : {
    pageNumber: number; pageSize: number; hasPaid?: boolean; searchTerm?: string;
  }) => {
    const params: any = { PageNumber: pageNumber, PageSize: pageSize, hasPaid };
    if (searchTerm && searchTerm.trim()) params.searchTerm = searchTerm.trim();
    const res = await apiCall().get(`MembershipSetUp/member/GetAllPendingSubscriptionInvoiceForStudent`, { params });
    return res.data;
  };

  // React Query: server-side paginated query
  const queryKey = ["outstanding-dues", currentPage, itemsPerPage, hasPaid, search];
  const { data, isLoading, isFetching, refetch } = useQuery(
    queryKey,
    async () => {
      // backend expects PageNumber 1-based
      return await fetchPage({ pageNumber: currentPage + 1, pageSize: itemsPerPage, hasPaid, searchTerm: search });
    },
    {
      keepPreviousData: true,
      staleTime: 1000 * 60 * 2, // 2 minutes
      retry: 1,
      onError: (err) => {
        console.error("Fetch outstanding dues error:", err);
      },
    }
  );

  // Update totalCount from data
  useEffect(() => {
    if (data && data.TotalCount !== undefined) {
      setTotalCount(data.TotalCount);
    }
  }, [data]);

  // Data extraction with safe defaults
  const serverItems: any[] = data?.Data ?? data?.reportItems ?? [];
  const pageCount = totalCount ? Math.max(1, Math.ceil(totalCount / itemsPerPage)) : 1;

  // Keep itemOffset in sync with currentPage
  useEffect(() => {
    setItemOffset(currentPage * itemsPerPage);
  }, [currentPage]);

  // Reset currentPage if it exceeds pageCount
  useEffect(() => {
    if (currentPage >= pageCount) {
      setCurrentPage(0);
    }
  }, [pageCount, currentPage]);

  // Reset totalCount and currentPage when hasPaid changes
  useEffect(() => {
    setTotalCount(null);
    setCurrentPage(0);
  }, [hasPaid]);

  // Debounced search input handling (only search triggers reset to page 0)
  useEffect(() => {
    if (searchDebounceRef.current) {
      window.clearTimeout(searchDebounceRef.current);
      searchDebounceRef.current = null;
    }
    // Wait 350ms after user stops typing
    searchDebounceRef.current = window.setTimeout(() => {
      setTotalCount(null);
      setCurrentPage(0); // reset to first page on new search
      // react-query will refetch because queryKey includes search and currentPage
    }, 350);

    return () => {
      if (searchDebounceRef.current) {
        window.clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = null;
      }
    };
  }, [search]); // only search should debounce

  // Handlers
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const handleReload = () => {
    setSearch("");
    setHasPaid(false);
    setTotalCount(null);
    setCurrentPage(0);
    // refetch to ensure fresh page 1
    refetch();
  };

  const handlePageClick = (event: any) => {
    const selected = event.selected;
    if (selected < pageCount) setCurrentPage(selected);
  };

  // Download mutation (kept your behavior, cleaned)
  const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
    mutationKey: ['download-pending-invoices', hasPaid],
    mutationFn: async () => {
      const url = `/MembershipSetUp/member/downloadAllPendingSubscriptionInvoiceForStudent?searchQuery=${encodeURIComponent(search || "")}&hasPaid=${hasPaid}&PageNumber=1&PageSize=50`;
      const method = "POST";
      const body = method === "POST" ? JSON.stringify({}) : undefined;

      let token = "";
      try {
        const tokenModel = JSON.parse(localStorage.getItem("token") || "null");
        token = tokenModel?.Token || tokenModel || "";
      } catch (err) {
        console.error("Token parse error:", err);
      }
      if (!token) throw new Error("Unauthorized: No token found.");

      const config = {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
        "Content-Type": "application/json",
      };

      return await downloadApi(url, method, body, config, true);
    },
    onSuccess: (blobData: any) => {
      if (blobData && blobData.size) {
        const url = window.URL.createObjectURL(new Blob([blobData]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Outstanding-Due-report.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        set_notification({ type: "success", message: "Outstanding Due Reports downloaded successfully" });
      } else {
        set_notification({ type: "error", message: "Oops! Error occurred while trying to download file" });
      }
      set_Nopen(true);
    },
    onError: (err: any) => {
      console.error("Download Error:", err);
      set_notification({ type: "error", message: err?.message || "Error occurred" });
      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    },
  });

  // UI rendering
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <TopDisplay
            label="Outstanding Dues Report"
            button_array={[
              <Button
                color="var(--white-color)"
                bg="var(--dark-green-color)"
                leftIcon={<DownloadIcon />}
                onClick={() => handleDownload()}
                disabled={isDownloading}
              >
                {isDownloading ? "Downloading..." : "Download Outstanding Due Report"}
              </Button>,
            ]}
          />

          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>

              <Input value={search} onChange={handleSearch} type="text" placeholder="Search by Student No" />

              <span
                style={{
                  position: "absolute",
                  zIndex: "1",
                  right: "10px",
                  cursor: "pointer",
                  top: "12px",
                }}
                onClick={handleReload}
                title="Reset Filters"
              >
                <ReloadIcon />
              </span>
            </InputGroup>

            {/* Optional: hasPaid toggle if needed */}
            {/* <Checkbox isChecked={hasPaid} onChange={(e)=>{ setHasPaid(e.target.checked); setCurrentPage(0); }}>
              Has Paid
            </Checkbox> */}
          </Flex>

          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">
              All Outstanding Due Reports
            </Heading>
            <Text m="0" fontSize=".8rem">
              Showing {itemOffset + 1} - {Math.min(itemOffset + itemsPerPage, totalCount || 0)} of {totalCount || 0}
              {isFetching ? " (loading...)" : ""}
            </Text>
          </Flex>

          {serverItems && serverItems.length > 0 ? (
            <TableContainer mt="20px">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th sx={HeadStyle}>Name</Th>
                    <Th sx={HeadStyle}>StudentNo</Th>
                    <Th sx={HeadStyle}>Membership-Type</Th>
                    <Th sx={HeadStyle}>Outstanding-Amount</Th>
                    <Th sx={HeadStyle}>DueYear</Th>
                    <Th sx={HeadStyle} w="50px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {serverItems.map((row: any, index: number) => (
                    <ROWSTYLE key={row.MembershipNo ?? row.MembershipNo + "-" + index}>
                      <Td sx={DataStyle}>{row.Name || "N/A"}</Td>
                      <Td sx={DataStyle}>{row.MembershipNo || "N/A"}</Td>
                      <Td sx={DataStyle}>{row.MembershipType || "N/A"}</Td>
                      <Td sx={DataStyle}>{row.OutstandingAmount ?? "N/A"}</Td>
                      <Td sx={DataStyle}>{row.DueYear ?? "N/A"}</Td>
                      <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                        <div className={activeIndex === index ? "active" : ""}>
                          <Option {...{ index, candidate: row }} />
                        </div>
                      </Td>
                    </ROWSTYLE>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <Text mt="20px">No Pending dues</Text>
          )}

          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              forcePage={currentPage}
              renderOnZeroPageCount={null}
            />
          </StylePaginateBox>
        </Box>
      )}
    </>
  );
}


const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom)
  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }
  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'View Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

  
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}
const ViewProfile = (props:any) =>{
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
      {/* <Image
        src="/public-assets/profile.png"
        width="150px"
        height="150px"
        objectFit="contain"
        objectPosition="center"
        alt="profile"
      /> */}
      <Flex gap="20px">
        {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
        <Text width="150px"  fontWeight="500" color="var(--light-text)"> Name</Text>
        <Text> {props.candidate.Name}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
     
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">StudentNo</Text>
        <Text fontWeight="500">{props.candidate.MembershipNo || 'N/A'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Membership Type</Text>
        <Text fontWeight="500">
          {props.candidate.MembershipType || 'N/A'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Outstanding Amount</Text>
        <Text fontWeight="500">
          {props.candidate.OutstandingAmount||'N/A'}
        </Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Due Year</Text>
        <Text fontWeight="500">
          {props.candidate.DueYear||'N/A'}
        </Text>
      </GridItem >
    </Grid>
  </Flex>
  )}


  